import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import './style.css'; // Importando o CSS para animações
import Swal from 'sweetalert2'

import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

interface AlertSuccessCatProps {
    message: string;
    onClose: () => void;
    show: boolean;
} 
 
const AlertSuccessCat: React.FC<AlertSuccessCatProps> = ({ message, onClose, show }) => {
    useEffect(() => {
        if (show) {
            Swal.fire({
                title: '',
                text: message,
                icon: 'success',
                confirmButtonText: 'Ok',
                background: 'var(--background-post)',
                confirmButtonColor: 'var(--primary-blue)',
                color: 'var(--color-text-post)',
                backdrop: `
                    rgb(0 80 123 / 40%)
                    url("/img/nyan-cat.gif")
                    left top
                    no-repeat
                `
            }).then(() => {
                onClose(); // Fecha o alerta após confirmação
            });
        }
    }, [show, message, onClose]);

    return null; // O componente não renderiza nada na DOM
};

export default AlertSuccessCat;
